// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-rail {
  display: flex;
  flex-direction: column;
  width: 4.5rem;
  min-width: 4.5rem;
  height: 100vh;
  background: var(--surface-sidebar);
  border-right: 1px solid var(--border-default);
  padding: 0.75rem 0;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
}

.rail-top,
.rail-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.rail-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.12s;
}
.rail-btn ion-icon {
  font-size: 1.3rem;
  color: var(--sidebar-text);
  transition: color 0.12s;
}
.rail-btn:hover {
  background: var(--sidebar-hover);
}
.rail-btn:hover ion-icon {
  color: var(--sidebar-text-bright);
}
.rail-btn:hover .rail-label {
  color: var(--sidebar-text-bright);
}
.rail-btn.active {
  background: var(--sidebar-active);
}
.rail-btn.active ion-icon {
  color: var(--sidebar-text-bright);
}
.rail-btn.active .rail-label {
  color: var(--sidebar-text-bright);
}

.rail-label {
  font-size: 0.6rem;
  color: var(--sidebar-text-muted);
  white-space: nowrap;
  line-height: 1;
  transition: color 0.12s;
}

::ng-deep .rail-notification .bell-wrapper {
  display: flex;
  justify-content: center;
}
::ng-deep .rail-notification .bell-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 8px;
  background: transparent !important;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: background 0.12s;
}
::ng-deep .rail-notification .bell-btn:hover {
  background: var(--sidebar-hover) !important;
}
::ng-deep .rail-notification .bell-btn:hover ion-icon {
  color: var(--sidebar-text-bright) !important;
}
::ng-deep .rail-notification .bell-btn ion-icon {
  font-size: 1.3rem !important;
  color: var(--sidebar-text) !important;
  transition: color 0.12s;
}
::ng-deep .rail-notification .bell-btn .badge {
  top: 0.25rem;
  right: 0.25rem;
}
::ng-deep .rail-notification .notification-dropdown {
  top: auto;
  bottom: 0;
  right: auto;
  left: 100%;
  margin-left: 0.5rem;
}

.avatar-wrapper {
  position: relative;
}

.avatar-btn {
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
}

::ng-deep .rail-avatar {
  width: 2.25rem !important;
  height: 2.25rem !important;
  border-radius: 8px !important;
  font-size: 0.75rem !important;
}

.profile-popover-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
}

.profile-popover {
  position: absolute;
  bottom: 0;
  left: calc(100% + 0.5rem);
  width: 16rem;
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 10001;
  overflow: hidden;
}

.popover-user {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem;
}

::ng-deep .popover-avatar {
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 8px !important;
  font-size: 0.6rem !important;
  flex-shrink: 0;
}
::ng-deep .popover-avatar img {
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 8px !important;
  object-fit: cover;
}

.popover-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.popover-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popover-email {
  font-size: 0.7rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popover-divider {
  height: 1px;
  background: var(--border-default);
}

.popover-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.8rem;
  color: var(--text-primary);
  transition: background 0.1s;
}
.popover-item ion-icon {
  font-size: 1.1rem;
  color: var(--text-secondary);
}
.popover-item:hover {
  background: var(--surface-tertiary);
}
.popover-item:active {
  background: var(--surface-active);
}

.popover-logout {
  color: var(--color-danger);
}
.popover-logout ion-icon {
  color: var(--color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/icon-rail/icon-rail.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,kCAAA;EACA,6CAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AACF;;AAEA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;AACF;AACE;EACE,iBAAA;EACA,0BAAA;EACA,uBAAA;AACJ;AAEE;EACE,gCAAA;AAAJ;AAEI;EACE,iCAAA;AAAN;AAGI;EACE,iCAAA;AADN;AAKE;EACE,iCAAA;AAHJ;AAKI;EACE,iCAAA;AAHN;AAMI;EACE,iCAAA;AAJN;;AASA;EACE,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;AANF;;AAWE;EACE,aAAA;EACA,uBAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,4BAAA;AATJ;AAWI;EACE,2CAAA;AATN;AAWM;EACE,4CAAA;AATR;AAaI;EACE,4BAAA;EACA,qCAAA;EACA,uBAAA;AAXN;AAcI;EACE,YAAA;EACA,cAAA;AAZN;AAgBE;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AAdJ;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,6BAAA;AAfF;;AAmBA;EACE,eAAA;EACA,QAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,kCAAA;EACA,uCAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,cAAA;AAhBF;AAkBE;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,iBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,iCAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,2BAAA;AAjBF;AAmBE;EACE,iBAAA;EACA,4BAAA;AAjBJ;AAoBE;EACE,mCAAA;AAlBJ;AAqBE;EACE,iCAAA;AAnBJ;;AAuBA;EACE,0BAAA;AApBF;AAsBE;EACE,0BAAA;AApBJ","sourcesContent":[".icon-rail {\n  display: flex;\n  flex-direction: column;\n  width: 4.5rem;\n  min-width: 4.5rem;\n  height: 100vh;\n  background: var(--surface-sidebar);\n  border-right: 1px solid var(--border-default);\n  padding: 0.75rem 0;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 100;\n}\n\n.rail-top,\n.rail-bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.rail-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.15rem;\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: 8px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background 0.12s;\n\n  ion-icon {\n    font-size: 1.3rem;\n    color: var(--sidebar-text);\n    transition: color 0.12s;\n  }\n\n  &:hover {\n    background: var(--sidebar-hover);\n\n    ion-icon {\n      color: var(--sidebar-text-bright);\n    }\n\n    .rail-label {\n      color: var(--sidebar-text-bright);\n    }\n  }\n\n  &.active {\n    background: var(--sidebar-active);\n\n    ion-icon {\n      color: var(--sidebar-text-bright);\n    }\n\n    .rail-label {\n      color: var(--sidebar-text-bright);\n    }\n  }\n}\n\n.rail-label {\n  font-size: 0.6rem;\n  color: var(--sidebar-text-muted);\n  white-space: nowrap;\n  line-height: 1;\n  transition: color 0.12s;\n}\n\n// Notification bell adapted for dark rail\n::ng-deep .rail-notification {\n  .bell-wrapper {\n    display: flex;\n    justify-content: center;\n  }\n\n  .bell-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 3.25rem;\n    height: 3.25rem;\n    border-radius: 8px;\n    background: transparent !important;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover {\n      background: var(--sidebar-hover) !important;\n\n      ion-icon {\n        color: var(--sidebar-text-bright) !important;\n      }\n    }\n\n    ion-icon {\n      font-size: 1.3rem !important;\n      color: var(--sidebar-text) !important;\n      transition: color 0.12s;\n    }\n\n    .badge {\n      top: 0.25rem;\n      right: 0.25rem;\n    }\n  }\n\n  .notification-dropdown {\n    top: auto;\n    bottom: 0;\n    right: auto;\n    left: 100%;\n    margin-left: 0.5rem;\n  }\n}\n\n.avatar-wrapper {\n  position: relative;\n}\n\n.avatar-btn {\n  padding: 0;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n::ng-deep .rail-avatar {\n  width: 2.25rem !important;\n  height: 2.25rem !important;\n  border-radius: 8px !important;\n  font-size: 0.75rem !important;\n}\n\n// Profile popover\n.profile-popover-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n}\n\n.profile-popover {\n  position: absolute;\n  bottom: 0;\n  left: calc(100% + 0.5rem);\n  width: 16rem;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  z-index: 10001;\n  overflow: hidden;\n}\n\n.popover-user {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.75rem;\n}\n\n::ng-deep .popover-avatar {\n  width: 2rem !important;\n  height: 2rem !important;\n  border-radius: 8px !important;\n  font-size: 0.6rem !important;\n  flex-shrink: 0;\n\n  img {\n    width: 2rem !important;\n    height: 2rem !important;\n    border-radius: 8px !important;\n    object-fit: cover;\n  }\n}\n\n.popover-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.popover-name {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.popover-email {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.popover-divider {\n  height: 1px;\n  background: var(--border-default);\n}\n\n.popover-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.8rem;\n  color: var(--text-primary);\n  transition: background 0.1s;\n\n  ion-icon {\n    font-size: 1.1rem;\n    color: var(--text-secondary);\n  }\n\n  &:hover {\n    background: var(--surface-tertiary);\n  }\n\n  &:active {\n    background: var(--surface-active);\n  }\n}\n\n.popover-logout {\n  color: var(--color-danger);\n\n  ion-icon {\n    color: var(--color-danger);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
